export const ru = {
    'banner-id': '№ {id}',
    'show-banner-types': 'Показать все типы'
};
